import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { useProductLink } from '@grandvisionhq/products';
import { useIntl } from '@grandvisionhq/state';
import { getNestedProperty, getLocalizedValue, getAttrValue } from '@grandvisionhq/utils';
import { ProductSuggestion } from '../components/ProductSuggestion.js';
import { getProductImageUrl } from '../utils/getProductImageUrl.js';

const ProductSuggestionContainer = ({ suggestion , onClick  })=>{
    const { locale  } = useIntl();
    const props = React.useMemo(()=>{
        const productType = getNestedProperty(suggestion, 'productType.obj.name');
        const isContactLens = CommerceToolsApi.isLenses(productType);
        const isSolutions = CommerceToolsApi.isSolutions(productType);
        var _name;
        const name = isContactLens ? getLocalizedValue(suggestion.name, locale) : (_name = suggestion.masterVariant.name) !== null && _name !== void 0 ? _name : '';
        const brand = String(getAttrValue(suggestion.masterVariant, 'brand')) || '';
        const sku = getNestedProperty(suggestion, 'masterVariant.sku');
        const slug = suggestion.slug;
        if (!brand || !name || !productType || !slug || !sku) {
            return null;
        }
        const imageUrl = getProductImageUrl(suggestion);
        return {
            isContactLens,
            isSolutions,
            name,
            brand,
            imageUrl
        };
    }, [
        suggestion,
        locale
    ]);
    const productUrl = useProductLink(suggestion.slug, getNestedProperty(suggestion, 'masterVariant.sku'), getNestedProperty(suggestion, 'productType.obj.name'));
    const onSuggestionClick = React.useCallback(()=>{
        onClick && onClick(suggestion.objectID, suggestion.position);
    }, [
        suggestion,
        onClick
    ]);
    if (!props) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ProductSuggestion, swcHelpers.extends({}, props, {
        productUrl: productUrl,
        onClick: onSuggestionClick
    }));
};

export { ProductSuggestionContainer, ProductSuggestionContainer as default };
//# sourceMappingURL=ProductSuggestionContainer.js.map
